<template>
  <div class="Logindiv">
    <div class="logodiv">
      <img src="../../static/images/henting3.png" v-if="pageType==2" />
      <img src="../../static/images/header_logo.png" v-else-if="pageType==3" />
      <img src="../../static/images/zhangguizhinang.png" style="margin-bottom: 50px;width: 70%;" v-else-if="pageType==4" />
      <img src="../../static/images/xinyin-logo.png" v-else-if="pageType==5" />
      <img src="../../static/images/logohdpi.png" v-else />
    </div>
    <div class="inputdiv">
      <span>
        <img src="../../static/images/house.png" />
      </span>
      <input placeholder="门店编号" type="number" v-model="shopCode" @focus="focus($event)" />
    </div>
    <div class="inputdiv">
      <span>
        <img src="../../static/images/member.png" />
      </span>
      <input placeholder="员工编号" type="number" v-model="memberCode" @focus="focus($event)" />
    </div>
    <div class="inputdiv">
      <span>
        <img src="../../static/images/password.png">
      </span>
      <input placeholder="密码" type="password" v-model="passwordCode" @focus="focus($event)" @keyup.enter="onLogin()" />
    </div>
    <div class="btn">
      <button @click="onLogin">登录</button>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  import {interfaceFn} from '@/assets/util.js'
  import phoneUUID from '@/assets/phoneUUID';
  import Receipt from './Receipt';
  export default {
    name: "Login",

    data() {
      return {
        shopCode: '', //门店编号
        memberCode: '', //门店编号
        passwordCode: '', //密码
        pageType: 1, // 1使用自己的logo，2使阳光的logo，3智汇云，4掌柜智囊，5薪银
      };
    },
    components: { Receipt },

    created() {
      // function uuid() {
      //   var temp_url = URL.createObjectURL(new Blob());
      //   var uuid = temp_url.toString(); // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
      //   URL.revokeObjectURL(temp_url);
      //   return uuid.substr(uuid.lastIndexOf("/") + 1);
      // }
      // let Phoneuuid = window.localStorage.getItem("Phoneuuid")
      // let phoneid = ''
      // if (Phoneuuid) {
      //   phoneid = Phoneuuid;
      // }else{
      // window.localStorage.setItem("Phoneuuid",uuid())
      //   phoneid = uuid()
      // }

      let href = window.location.href;
      if (href.indexOf('yg.') != -1) {
        this.pageType = 2;
      } else if (href.indexOf('zhy.') != -1) {
        this.pageType = 3;
      } else if (href.indexOf('zgzn.') != -1) {
        this.pageType = 4;
      } else if (href.indexOf('xinyin.') != -1) {
        this.pageType = 5;
      } else {
        // http://localhost/
        this.pageType = 1;
      }

      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        // 通过下面这个API隐藏底部导航栏
        WeixinJSBridge.call('hideToolbar');
      });

      var isGuest = 0; //判断是顾客1还是店员0
      var query = this.$route.query || {}; //连接参数

      // 测试数据
      // http://localhost:8080/?tab=12048&mer=114&sho=160&openid=o346y1FHCNH9adAYVCgpl5-XSG8I
      // http://localhost:8080/?tab=12473&mer=151&sho=227&openid=123456
      if (Number(query.mer) > 0) { //判断是否是顾客扫码点餐
        localStorage.clear();
        window.localStorage.setItem("shopId", query.sho);
        window.localStorage.setItem("merchantId", query.mer);
        window.localStorage.setItem("tableId", query.tab);
        window.localStorage.setItem("fee", query.fee);
        isGuest = 1;
        window.localStorage.setItem("isGuest", isGuest);
        this.$store.state.isScan = true;
        this.$store.state.scanInfo = query;
        if (query.orderCode) {
          let loadingMsg = this.$loading({
            fullscreen: true
          });
          setTimeout(() => {
            loadingMsg.close();
            this.$router.push({
              path: '/ticket?orderCode=' + query.orderCode
            });
          }, 1500);
        } else if (query.out_trade_no) {
          // 商家小票
          this.$router.push({
            path: '/receipt',
            query: {
              out_trade_no: query.out_trade_no,
              sub_mch_id: query.sub_mch_id,
              check_code: query.check_code
            }
          });
        } else {
          this.$router.push({
            path: '/room'
          });
        }
      } else if (query.out_trade_no) {
        // 商家小票
        this.$router.push({
          path: '/receipt',
          query: {
            out_trade_no: query.out_trade_no,
            sub_mch_id: query.sub_mch_id,
            check_code: query.check_code
          }
        });
      } else {
        this.$store.state.isScan = false;
        this.$store.state.scanInfo = {};
        window.localStorage.setItem("isGuest", isGuest);
        var timestemp = window.localStorage.getItem("timestemp");
        var logintime = new Date().getTime();

        // 获取UUID
          function uuid() {
            var temp_url = URL.createObjectURL(new Blob());
            var uuid = temp_url.toString(); // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
            URL.revokeObjectURL(temp_url);
            return uuid.substr(uuid.lastIndexOf("/") + 1);
          }
          let Phoneuuid = window.localStorage.getItem("Phoneuuid")
          let phoneid = ''
          if (Phoneuuid) {
            phoneid = Phoneuuid;
          }else{
            window.localStorage.setItem("Phoneuuid",uuid())
            phoneid = uuid()
          }

        //console.log("距离上次打开登录界面不足24小时");//免登陆
        if (logintime - timestemp < 24 * 60 * 60 * 1000) {
          // 判定用户在线
          let http = this.$http.post(interfaceFn() + '/shopService/onlineQty', qs.stringify({
            "shopId": window.localStorage.getItem("shopId"),
            "type": 6,
            "diskSerialNumber": phoneid
          })).then(res => {
            let data = res.data;
            if (res.data.data.shopOnlineNumber == 0 || res.data.data.shopOnlineNumber > res.data.data.onlineQty) {
              this.$router.push({
                path: "/home"
              });
              this.$store.state.first += 1;
              // 获取用户登录手机型号和uuid
                phoneUUID(1)
            }else{
              this.$Message({
                type:'warning',
                message:'您的账号已在其他设备登录'
              })
              localStorage.clear();
              this.$router.push({
                path: "/"
              });
              loadingInstance.close();
            }
          })
        } else {
          return;
        }
      }
    },

    mounted() {
      // console.log(this.$store.state.first);
      var loginInfo = JSON.parse(window.localStorage.getItem("logindata"));
      if (loginInfo) {
        this.shopCode = loginInfo.shopCode;
        this.memberCode = loginInfo.memberCode;
        this.passwordCode = loginInfo.passwordCode;
      }

      // var string = "1129\n";
      // string = string.replace(/\r\n/g,"")
      // console.log(string);
    },

    methods: {
      focus(event) {
        event.currentTarget.select();
      },
      onLogin() {
        var memberCode = this.memberCode;
        var shopCode = this.shopCode;
        var passwordCode = this.passwordCode;
        var logindata = {}; //用户登陆的信息
        var curTime = new Date().getTime(); //当前的时间戳

        if (!shopCode) {
          this.msgFn('warning', '门店编号不能为空', 1000);
          return;
        }

        if (!memberCode) {
          this.msgFn('warning', '员工编号不能为空', 1000);
          return;
        }

        if (!passwordCode) {
          this.msgFn('warning', '密码不能为空', 1000);
          return;
        }

        let loadingInstance = this.$loading({
          fullscreen: true
        });

        // 获取UUID
        function uuid() {
          var temp_url = URL.createObjectURL(new Blob());
          var uuid = temp_url.toString(); // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
          URL.revokeObjectURL(temp_url);
          return uuid.substr(uuid.lastIndexOf("/") + 1);
        }
        let Phoneuuid = window.localStorage.getItem("Phoneuuid")
        let phoneid = ''
        if (Phoneuuid) {
          phoneid = Phoneuuid;
        }else{
          window.localStorage.setItem("Phoneuuid",uuid())
          phoneid = uuid()
        }

        this.$http.post(interfaceFn()+'/user/login',
          qs.stringify({
            code: memberCode,
            mobile: shopCode,
            password: passwordCode
          }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          loadingInstance.close();
          if (res.data.returnCode == 'ok') {
            let data = res.data.user;
            let Phoneid = window.localStorage.getItem("Phoneuuid")
            window.localStorage.clear()
            window.localStorage.setItem("Phoneuuid",Phoneid)
            // window.localStorage.removeItem('userInfo')
            // window.localStorage.removeItem('timestemp')
            // window.localStorage.removeItem('isGuest')
            // window.localStorage.removeItem('logindata')
            logindata.memberCode = memberCode;
            logindata.shopCode = shopCode;
            logindata.passwordCode = passwordCode;
            logindata = JSON.stringify(logindata);
            window.localStorage.setItem("logindata", logindata);
            window.localStorage.setItem("timestemp", curTime);
            window.localStorage.setItem("userInfo", JSON.stringify(data));
            window.localStorage.setItem("shopId", data.shopId);
            // 判定用户在线
            let http = this.$http.post(interfaceFn() + '/shopService/onlineQty',
              qs.stringify({
                "shopId": data.shopId,
                "type": 6,
                "diskSerialNumber": phoneid
              })
            ).then(res =>{
              if (res.data.code != 0) {
                this.$Message({
                  type: 'warning',
                  message: res.data.msg
                })
                // this.$router.push({
                //   path: "/home"
                // });
                return;
              }
							if (res.data.data.shopOnlineNumber == 0 || res.data.data.shopOnlineNumber > res.data.data.onlineQty) {
                this.$router.push({
                  path: "/home"
                });
                this.$store.state.first += 1;
                // 获取用户登录手机型号和uuid
                	phoneUUID(1)
              }else{
                this.$Message({
                  type:'warning',
                  message:'您的账号已在其他设备登录'
                })
                localStorage.clear();
                this.$router.push({
                  path: "/"
                });
              loadingInstance.close();
              }
          })
          } else {
              this.msgFn('warning', res.data.message, 1500);
          }
        }).catch((error) => {
          loadingInstance.close();
          this.msgFn('error', '服务器错误，请稍后重试', 1000);
        });
      },

      // 提示
      msgFn(type, msg, time) {
        this.$Message({
          duration: time,
          //showClose: true,
          message: msg,
          center: true,
          type: type
        });
      },

    },
  }
</script>

<style scoped>
  .Logindiv {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    font-size: 0.75em;
    background: #fff;
    overflow: auto;
  }

  .logodiv {
    padding: 3.25rem 0;
    text-align: center;
  }

  .logodiv img {
    width: 110px;
  }

  .tiptext {
    width: 100%;
    text-align: center;
  }

  .inputdiv {
    margin: 0px 10%;
    float: left;
    width: 80%;
    height: auto;
    border-bottom: 1px solid #e3e9eb;
    display: flex;
    align-items: center;
  }

  .inputdiv input {
    flex-grow: 1;
    padding: 10px 0px;
    line-height: 40px;
    color: #c6cdd4;
    font-size: 1.5em;
    border: none;
    background: #fff;
  }

  .inputdiv input:focus {
    outline: none;
  }

  .inputdiv span {
    margin-right: 1.5625em;
  }

  .btdiv {
    width: 100%;
    margin: 1.25em auto;
  }

  .btn button {
    border: none;
    padding: 0.625em;
    margin: 0px 10%;
    margin-top: 20px;
    width: 80%;
    background-color: rgb(230, 117, 0);
    font-family: PingFangSC-Regular;
    font-size: 1.25em;
    color: #fff;
    line-height: 32px;
    border-radius: 4px;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue